export default "__VITE_ASSET__Pyoi1AmB__"